import { CacheConfig, CacheStatus, getCachedItem, setCacheItem, setCacheStatus } from '@r-and-a-shared-ui/core-caching';
import { deliveryClient } from '../config/kontent-delivery-client';
import type { Article } from '../models/MEMBERSHIP';

export const getLatestArticlesBodyOnly = async (
  limit: number,
  cache = true,
  cacheTTL = CacheConfig.TTL.LatestArticles.valueOf(),
  cacheStatus?: CacheStatus,
) => {
  try{
    const cacheKey = 'getLatestArticlesBodyOnly';

    const cachedItem = getCachedItem<Article[]>(cacheKey, cache);

    if (cachedItem) {
      setCacheStatus(cacheStatus, {
        cacheable: cache,
        xInMemoryCache: CacheConfig.Hit,
        cacheTTL,
      });
      return {
        articles: cachedItem,
      };
    }

    const latestArticlesResponse = await deliveryClient
      .items<Article>()
      .type('article')
      .orderParameter('elements.publish_date', 'desc')
      .excludeElementsParameter([
        'elements_below_article_body',
        'sidebar',
        'article_preview',
        'template',
        'url_slug',
        'seo__meta_title',
        'seo__meta_description',
        'seo__key_words',
        'seo__no_index',
        'seo__no_follow',
        'subheader_elements',
      ])
      .limitParameter(limit)
      .toPromise();

    setCacheItem(cacheKey, latestArticlesResponse.data.items, cacheTTL, cache);

    setCacheStatus(cacheStatus, {
      cacheable: cache,
      xInMemoryCache: CacheConfig.Miss,
      cacheTTL,
    });

    return {
      articles: latestArticlesResponse.data.items,
    };
  } catch (error) {
    console.error('Error in getLatestArticlesBodyOnly', error);
    throw error;
  }
};